/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

interface PiedInseeProps {
  message?: React.ReactNode;
  children?: React.ReactNode;
}

/** Pied d'un écran INSEE : message à gauche, boutons à droite */
const PiedInsee = ({ message, children }: PiedInseeProps) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '1em',
    }}
  >
    <div style={{ textAlign: 'left' }}>{message}</div>
    <div style={{ display: 'flex', gap: '0.5em', flexShrink: 0 }}>
      {children}
    </div>
  </div>
);

export default PiedInsee;
